import firebase from 'firebase/app'
import config from '@/config'

firebase.initializeApp(config.firebase)



// WEBPACK FOOTER //
// ./src/services/firebase-init.js